import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "common/assets/css/App.css";
import {
  HashRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import AuthLayout from "./layouts/auth";
import AdminLayout from "layouts/admin";
import UserLayout from "layouts/user";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "common/theme/theme";
import { ThemeEditorProvider } from "@hypertheme-editor/chakra-ui";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import store from "./common/redux/store";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./common/authConfig";
import qs from "qs";
import { SSOProvider } from "common/contexts/SSOContext";
import "./i18n";
import { SSORole } from "common/contexts/SSOContext";
import { saveDataToStorage } from "common/utils/storage";
import { constant } from "common/constant";
import axios from "axios";

// Create MSAL instance outside of App component
const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const codeValue = urlParams.get("code");
  const { codeVerifier } = SSORole();
  const navigate = useNavigate();
  useEffect(() => {
    if (codeValue) saveDataToStorage(constant.authCode, codeValue);
  }, [codeVerifier]); // Include codeVerifier in the dependency array

  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));
  useNavigate();
  const location = useLocation(); // Get current route

  useEffect(() => {
    async function authHandle() {
      async function authCode() {
        const data = qs.stringify({
          grant_type: constant.authorizationCode,
          client_id: constant.clientID,
          code: codeValue,
          redirect_uri: constant.redirectPath,
          scope: constant.scope,
          code_verifier: localStorage.getItem("code-verifier"),
        });

        const config = {
          method: "post",
          maxBodyLength: Infinity,
          url: "https://login.microsoftonline.com/common/oauth2/v2.0/token",
          headers: {
            Accept: "*/*",
            "Accept-Language": "en-US,en;q=0.9,hi;q=0.8",
          },
          data: data,
        };

        try {
          const response = await axios.request(config);

          if (response.data) {
            saveDataToStorage(
              constant.refreshToken,
              response.data.refresh_token
            );
            saveDataToStorage(
              constant.outlookAccessToken,
              response.data.access_token
            );
          }
          window.history.replaceState({}, document.title, "/");

          navigate("/crm/default", { replace: true });
        } catch (error) {
          console.error(error);
        }
      }

      await authCode();
    }
    if (codeValue) authHandle();
  }, [codeValue]);
  useEffect(() => {
    if (token && user?.role && location.pathname === "/") {
      navigate("/crm/default");
    }
  }, [token, user?.role, location.pathname, navigate]);
  return (
    <>
      <ToastContainer />
      <Routes>
        {token && user?.role ? (
          user?.role == "user" ? (
            <Route path="/*" element={<UserLayout />} />
          ) : user?.role === "superAdmin" ? (
            <Route path="/*" element={<AdminLayout />} />
          ) : (
            ""
          )
        ) : (
          <Route path="/*" element={<AuthLayout />} />
        )}
      </Routes>
    </>
  );
}

ReactDOM.render(
  <Provider store={store}>
    <ChakraProvider theme={theme}>
      <React.StrictMode>
        <ThemeEditorProvider>
          <Router>
            <SSOProvider>
              <MsalProvider instance={msalInstance}>
                <GoogleOAuthProvider
                  clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                >
                  <App />
                </GoogleOAuthProvider>
              </MsalProvider>
            </SSOProvider>
          </Router>
        </ThemeEditorProvider>
      </React.StrictMode>
    </ChakraProvider>
  </Provider>,
  document.getElementById("root")
);
